import React from 'react';

const BtcIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="img"
    {...props}
  >
    <circle cx="16" cy="16" r="16" fill="#F7931A" />
    <path 
      fill="#FFF" 
      d="M14.28 24.814V7.186h5.857c1.857 0 3.143.286 4 .857a4.286 4.286 0 0 1 2.286 3.429c0 1.571-.571 2.714-1.714 3.429a4.857 4.857 0 0 1-2.857.857c1.714.429 2.857 1.429 3.429 3a4 4 0 0 1 .571 2.286c0 1.857-.714 3.143-2.143 4a4.571 4.571 0 0 1-3.286 1.143h-6.143zm2.571-14.857v5.143h2.429c1.286 0 2.143-.286 2.571-.857a2.571 2.571 0 0 0 .571-1.714c0-1.143-.429-1.857-1.286-2.143a4.857 4.857 0 0 0-1.857-.429h-2.429zm0 7.714v5.143h2.857c1.286 0 2.286-.286 3-.857a2.857 2.857 0 0 0 .857-2c0-1.286-.571-2.143-1.714-2.571a8.571 8.571 0 0 0-2-.286h-2.857zM14.28 4.545V2.455h-2.143v2.09zM14.28 27.455v2.09h-2.143v-2.09z"
    />
  </svg>
);

export default BtcIcon;